import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { SiteHeader, SiteFooter } from '../components/SiteChrome';
import tags from '../data/case-study-tags.json';
import './SEOContent.css';

export default function CaseStudyIndex({ posts }) {
  const [model, setModel] = useState('');
  const [channel, setChannel] = useState('');
  const entries = Object.entries(tags).filter(([slug]) => posts[slug]);
  const visible = entries.filter(([, tag]) => (!model || tag[1] === model) && (!channel || tag[2] === channel));
  const models = [...new Set(entries.map(([, tag]) => tag[1]))].sort();
  const channels = [...new Set(entries.map(([, tag]) => tag[2]))].sort();
  const other = Object.entries(posts).filter(([slug]) => !tags[slug]);
  return <div className="f1000-site seo-page">
    <Seo title="First 1000 case studies by product type and acquisition approach" description="Find a company case study by the product it built and the early acquisition approach it used. Counts cover this site's public blog, not the newsletter archive." canonical="https://www.first1000.co/blog/case-studies" />
    <SiteHeader />
    <main id="main" className="seo-index">
      <Link to="/blog">All field notes</Link>
      <h1>Find a case you can use.</h1>
      <p className="seo-dek">{entries.length} company-focused case studies. {other.length} other essays and guides. {Object.keys(posts).length} public blog entries in total.</p>
      <p>This index counts the entries on this website, not every First 1000 newsletter issue. A case means a company-focused article; a cross-company essay is listed separately. The tags describe approaches discussed in the case, not a measured ranking of its acquisition channels.</p>
      <p>For a starting plan, read <Link to="/blog/marketplace-first-transactions">marketplace first transactions</Link> or <Link to="/blog/developer-tools-first-customers">developer-tool first customers</Link>.</p>
      <div className="case-filters">
        <label>Product type<select value={model} onChange={e => setModel(e.target.value)}><option value="">All models</option>{models.map(value => <option key={value}>{value}</option>)}</select></label>
        <label>Acquisition approach<select value={channel} onChange={e => setChannel(e.target.value)}><option value="">All approaches</option>{channels.map(value => <option key={value}>{value}</option>)}</select></label>
        {(model || channel) && <button type="button" onClick={() => { setModel(''); setChannel(''); }}>Clear filters</button>}
      </div>
      <p role="status">{visible.length} of {entries.length} case studies shown.</p>
      <div className="seo-table-wrap"><table className="seo-table">
        <thead><tr><th scope="col">Company</th><th scope="col">Product type</th><th scope="col">Approach</th><th scope="col">Read the case</th></tr></thead>
        <tbody>{visible.map(([slug, tag]) => <tr key={slug}><th scope="row">{tag[0]}</th><td>{tag[1]}</td><td>{tag[2]}</td><td><Link to={`/blog/${slug}`}>{posts[slug].title}</Link></td></tr>)}</tbody>
      </table></div>
      {!visible.length && <p>No case matches both filters. Clear one to broaden the list.</p>}
      <h2>Other essays and guides</h2>
      <ul>{other.map(([slug, post]) => <li key={slug}><Link to={`/blog/${slug}`}>{post.title}</Link></li>)}</ul>
    </main>
    <SiteFooter />
  </div>;
}
